import { JsonElementType, JsonObject, JsonProperty } from "ta-json";

import type { MapCultureTo } from "../../base-types";
import { OptionListType } from "../../contracts/base/option-lists/option-list-type";
import Link from "../../link";
import Resource from "../resource";
import OptionListValueResource from "./option-list-value-resource";
@JsonObject()
export default class OptionListResource extends Resource {
    @JsonProperty("name")
    name: string;

    @JsonProperty("labels")
    labels: MapCultureTo<string>;

    @JsonProperty("type")
    type: OptionListType;

    @JsonProperty("is_system_owned")
    isSystemOwned: boolean;

    @JsonProperty("values")
    @JsonElementType(OptionListValueResource)
    values: Array<OptionListValueResource>;

    @JsonProperty("created_on")
    createdOn?: Date;

    @JsonProperty("modified_on")
    modifiedOn?: Date;

    @JsonProperty("created_by")
    createdBy?: Link;

    @JsonProperty("modified_by")
    modifiedBy?: Link;
}

export { OptionListResource };
